import { Link } from "@tanstack/react-router"
import { Network } from "lucide-react"
import { useT } from "@/lib/i18n"
import { useScope } from "@/lib/scope"
import type { ObjectIdentity } from "@/lib/neighborhood"
import { cn } from "@/lib/utils"

/** Shared entry point; the concrete runtime identity, never a business-property guess. */
export function OpenInGraph({ object, className }: { object: ObjectIdentity; className?: string }) {
  const scope = useScope()
  const t = useT()
  return (
    <Link
      to="/$orgId/$environmentId/graph"
      params={scope}
      search={{ root: `${object.objectType}:${object.key}` }}
      onClick={(event) => event.stopPropagation()}
      onKeyDown={(event) => event.stopPropagation()}
      className={cn("inline-flex items-center gap-1.5 whitespace-nowrap text-xs text-muted-foreground transition-colors hover:text-primary [&_svg]:size-3.5", className)}
    >
      <Network aria-hidden /> {t("graph.open")}
    </Link>
  )
}
